import { SEGMENT_BUCKETS } from '../constants.ts';
import type { Group, SubGroup } from '../types.ts';
import { hasSegmentFee } from './hasSegmentFee.ts';
import { isMultipartnerSegment } from './marketOperatorRestrictions.ts';

export const containsPricedMultipartnerSegment = (
  group: Omit<Group, 'uuid'> | Omit<SubGroup, 'uuid'>,
  currentAccountId: string
): boolean => {
  if ('groups' in group) {
    return group.groups.some(subgroup => containsPricedMultipartnerSegment(subgroup, currentAccountId));
  }

  return SEGMENT_BUCKETS.some(bucket =>
    group[bucket]?.segments?.some(
      segment => isMultipartnerSegment(segment, currentAccountId) && hasSegmentFee(segment.price_pom, segment.price_cpm)
    )
  );
};
